import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import type {
  AxiosRequestConfig,
  AxiosError,
  AxiosRequestHeaders,
} from "axios";
import axiosInstance from "./axiosInstance";

type AxiosBaseQueryArgs = {
  baseUrl: string;
};
const axiosBaseQuery =
  ({
    baseUrl,
  }: AxiosBaseQueryArgs): BaseQueryFn<
    {
      url: string;
      method?: AxiosRequestConfig["method"];
      data?: AxiosRequestConfig["data"];
      params?: AxiosRequestConfig["params"];
      headers?: AxiosRequestHeaders;
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params, headers }) => {
    try {
      const result = await axiosInstance({
        url: baseUrl + url,
        method,
        data,
        params,
        headers,
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export default axiosBaseQuery;
